exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".nx-chat-customer{position:fixed;right:16px;bottom:16px;transform:scale(0.3);opacity:0;z-index:16777271;transition:all 0.3s ease-in-out}.nx-chat-customer--online{opacity:1;transform:scale(1)}\n", ""]);

